/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { getDoc, doc, setDoc, Timestamp } from 'firebase/firestore';
import Confetti from 'react-confetti';

import { db } from '../../firebase';
import { Section, Layout, SEO, ShareBar, BrowseWebGamesSection } from '..';
import { LoveBox } from './LoveBox';
import style from './LoveMessage.module.less';
import { sounds } from './LoveBox/GameSounds';
import { PLACEHOLDER } from './CreateMessage';
import { ETRSection } from './ETRSection';

import social from './assets/social.png';

export const LoveMessageBoxPage: React.FC = () => {
  const [stage, setStage] = useState(0);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const m = (new URLSearchParams(window.location.search)).get('m'); // single message
    const l = (new URLSearchParams(window.location.search)).get('l'); // multiple messages
    const docPath = m ? `love-puzzle/${m}` : `love-puzzle/${l}`;

    getDoc(doc(db, docPath))
      .then((ref) => {
        if (ref.exists()) {
          setMessage(ref.data().message);
          setDoc(doc(db, docPath), {
            lastOpenedAt: Timestamp.now()
          }, { merge: true });
        } else {
          window.location.assign('/404');
        }
      })
      .catch((err) => {
        console.error(err);
        window.location.assign('/404');
      });
  }, []);

  useEffect(() => {
    if (stage !== 2) {
      return;
    }
    const m = (new URLSearchParams(window.location.search)).get('m'); // single message
    const l = (new URLSearchParams(window.location.search)).get('l'); // multiple messages
    const docPath = m ? `love-puzzle/${m}` : `love-puzzle/${l}`;

    setDoc(doc(db, docPath), {
      lastSolvedAt: Timestamp.now()
    }, { merge: true });
  }, [stage]);

  return (
    <Layout>
      <SEO
        title="Puzzle Box"
        description="Someone has sent you a message hidden behind a series of puzzles. Can you solve the box and reveal it?"
        image={social}
      />
      {stage === 2 ? (<Confetti recycle={false} numberOfPieces={2000} tweenDuration={10000} />) : <></>}
      <Section>
        <div className={style.content}>
          <div className={classnames(style.row, style.previewRow)}>
            <div className={style.text}>
              {(() => {
                if (stage === 0) {
                  return (
                    <div className={style.intro}>
                      <div className={style.introMessage}>
                        <p>Hi,</p>
                        <p>Someone has a secret message for you.</p>
                        <p>However, it's locked away in a box. The only way to access it is to solve puzzles.</p>
                        <p>Please let me know when you're ready.</p>
                        <p>Good luck.</p>
                      </div>
                      <div className={style.fancyButtonContainer}>
                        <button
                          type="button"
                          className={style.fancyButton}
                          onClick={() => {
                            sounds.mystery();
                            setStage(1);
                          }}
                        >
                          I'm ready, show me the box!
                        </button>
                      </div>
                    </div>
                  );
                }

                if (stage === 1) {
                  return <LoveBox onFinished={() => setStage(2)} />;
                }

                if (stage === 2) {
                  return (
                    <div className={style.finalMessage}>{message || PLACEHOLDER}</div>
                  );
                }
                return <></>;
              })()}
            </div>
          </div>
        </div>
      </Section>

      <Section className={style.loveSection} alternate={true}>
        <div className={style.content}>
          <h1 className={style.header}>{stage === 2 ? 'Enjoyed' : 'Enjoying'} the box? Share!</h1>
          <div className={style.text}>
            <ShareBar title="I just received a hidden message in a cute box!" shareUrl="https://elevenpuzzles.com/message" />
          </div>
        </div>
      </Section>

      <Section className={style.loveSection}>
        <div className={style.content}>
          <h1 className={style.header}>Create your own box</h1>
          <div className={style.text}>
            <p>Create a hidden message, save and share! You can have your box ready in less than 5 minutes.</p>

            <Link activeClassName={style.active} to="/message" className={style.fancyButton}>Learn more</Link>
          </div>
        </div>
      </Section>

      <ETRSection alternate={true} />

      <BrowseWebGamesSection />
    </Layout>
  );
};
